import PcCode, { PcCodeDefaultProps } from "../models/PcCode";
import api from "./PcCodeApi";
import { t } from "@/plugins/i18n";

export class PcCodeStore{
  depots: PcCode[] = [];
  carBrands: PcCode[] = [];
  accInvGroups: PcCode[] = [];
  metisModells: PcCode[] = [];
  salesTypes: PcCode[] = [];
  carCategories: PcCode[] = [];

  dmsNat = {
    accNo: "",
    pc1: "",
    pc2: "",
    pc3: "",
    pc4: "",
    pc5: "",
    pc6: "",
  }

  async updatePcCode(item: PcCode){
    await api.updatePcCode(item);
  }

  async loadDepots() { 
    this.depots = await api.getPcCodesByType('mmgendepot');
  }
  async loadCarBrands() { 
    this.carBrands = await api.getPcCodesByType('csshccarbrand');
  }
  async loadAccInvGroups() { 
    this.accInvGroups = await api.getPcCodesByType('csaccinvgroup');
  }
  async loadMetisModells() { 
    this.metisModells = await api.getPcCodesByType('csmetmodell');
    this.metisModells.push({...PcCodeDefaultProps, pcCode: "??", valueNational: t("PcCode_NincsBeallitva"), displayText: t("PcCode_NincsBeallitva_2")});
  }
  async loadSalesTypes() { 
    this.salesTypes = await api.getPcCodesByType('csgensalestype');
  }
  async loadCarCategories() {
    this.carCategories = await api.getPcCodesByType('mscarcategory');
    this.carCategories.push({...PcCodeDefaultProps, pcCode: "?", valueNational: t("PcCode_NincsBeallitva"), displayText: t("PcCode_NincsBeallitva_3")});
  }

  async loadStore() { 
    await this.loadDepots()
    await this.loadCarBrands()
    await this.loadAccInvGroups()
    await this.loadMetisModells()
    await this.loadSalesTypes()
    await this.loadCarCategories()
  }

  getName (list: PcCode[], value: string) {
    if (!value || value === "0" || value === "00") return `MINDEGY (${value})`;
    if (!value || value === "-" || value === "--") return `ISMERETLEN (${value})`;
    if (!value || value === "?" || value === "??") return `ISMERETLEN (${value})`;
    const found = list.find(x => x.pcCode?.includes(value));    
    return `${found?.valueNational} (${found?.pcCode})`.toUpperCase();
  }

  getDmsNatFromCode(pcCode: string | null) {
    this.dmsNat = { accNo: "", pc1: "", pc2: "", pc3: "", pc4: "", pc5: "", pc6: ""};

    if (pcCode == null) return this.dmsNat;

    const parts = pcCode.split("_");
    if (parts.length !== 2) return this.dmsNat;

    const accNo = parts[0];
    const pcString = parts[1];
    
    this.dmsNat.accNo = `${accNo}*`
    this.dmsNat.pc1 = this.getName(this.depots, pcString[0]);
    this.dmsNat.pc2 = this.getName(this.carBrands, pcString[1]);
    this.dmsNat.pc3 = this.getName(this.metisModells, `${pcString[2]}${pcString[3]}`);
    this.dmsNat.pc4 = this.getName(this.accInvGroups, `${pcString[4]}${pcString[5]}`);
    this.dmsNat.pc5 = this.getName(this.salesTypes, pcString[6]);
    this.dmsNat.pc6 = this.getName(this.carCategories, pcString[7]);
  }
}

const store = new PcCodeStore()
export default store